import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

function ProtectedRoutes() {
  const isAuthenticated = useAuth();
  return <Outlet />;
}
export default ProtectedRoutes;
